import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'ic-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() total = 0;
  @Input() page = 1;
  @Input() pageSize = 10;
  @Input() showPageSize = 3;
  pages = [];
  @Output() changePage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {
    this.pages = this.getShowPage();
  }

  ngOnChanges() {
    this.pages = this.getShowPage();
  }

  gotoPage(page) {
    if (this.page == page) {
      return;
    }

    this.page = page;
    this.pages = this.getShowPage();
    this.changePage.emit(this.page);
  }

  maxPage() {
    return Math.ceil(this.total / this.pageSize);
  }

  hasNext() {
    if (this.page >= this.maxPage()) {
      return false;
    }

    return true;
  }

  hasPrevisous() {
    if (this.page <= 1) {
      return false;
    }

    return true;
  }

  next() {
    if (!this.hasNext()) {
      return;
    }

    this.gotoPage(this.page + 1);
  }

  previous() {
    if (!this.hasPrevisous()) {
      return;
    }

    this.gotoPage(this.page - 1);
  }

  getShowPage() {
    const range = Math.floor(this.showPageSize / 2);
    const startPage = Math.max(this.page - range, 1);
    const endPage = Math.min(this.page + range, this.maxPage());
    const pages = [];

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/pagination/pagination.component.ts